import {do_vacation_type} from "../Model/DBModel";

export const VACATION_TYPE_OPTIONS: { value: do_vacation_type; label: string; defaultPayRatio: number; affectsAnnual: 0 | 1 }[] = [
    { value: "연차",      label: "연차",        defaultPayRatio: 100, affectsAnnual: 1 },
    { value: "대체휴가",  label: "대체휴가",    defaultPayRatio: 100, affectsAnnual: 0 },
    { value: "병가",      label: "병가(무급)",  defaultPayRatio: 0,   affectsAnnual: 0 },
    { value: "고객사휴무", label: "고객사휴무(70%)", defaultPayRatio: 70, affectsAnnual: 0 },
    { value: "경조휴가",  label: "경조휴가(유급)", defaultPayRatio: 100, affectsAnnual: 0 },
    { value: "기타",      label: "기타",        defaultPayRatio: 100, affectsAnnual: 0 },
]

export const VACATION_UNIT_OPTIONS: { value: number; label: string }[] = [
    { value: 1.0,   label: "종일 (1.0)" },
    { value: 0.5,   label: "반차 (0.5)" },
]

export const VACATION_PERIOD_OPTIONS: { value: string; label: string }[] = [
    { value: "오전", label: "오전" },
    { value: "오후", label: "오후" },
]

export const VACATION_OPTIONS: { key: string; label: string; type: do_vacation_type; unit: number; period?: string }[] = [
    { key: "연차",           label: "연차",            type: "연차",       unit: 1.0   },
    { key: "반차(오전)",     label: "반차(오전)",      type: "연차",       unit: 0.5, period: "오전" },
    { key: "반차(오후)",     label: "반차(오후)",      type: "연차",       unit: 0.5, period: "오후" },
    { key: "대체휴가",       label: "대체휴가",          type: "대체휴가",    unit: 1.0   },
    { key: "병가(무급)",     label: "병가(무급)",        type: "병가",       unit: 1.0   },
    { key: "고객사휴무(70%)", label: "고객사휴무(70%)",  type: "고객사휴무",   unit: 1.0   },
    { key: "경조휴가(유급)", label: "경조휴가(유급)",    type: "경조휴가",    unit: 1.0   },
    { key: "기타",          label: "기타",            type: "기타",       unit: 1.0   },
]

export const VACATION_CHIP_COLOR: Record<do_vacation_type, string> = {
    연차:        "#52C41A",
    대체휴가:    "#13C2C2",
    병가:        "#FF4D4F",
    고객사휴무:  "#FAAD14",
    경조휴가:    "#722ED1",
    기타:        "#8C8C8C",
}

// 캘린더 칩 단순화: 휴가(녹색) / 반차(파란)
export const VACATION_CALENDAR_CHIP = {
    휴가: "#52C41A",
    반차: "#1677FF",
}

export const VACATION_ROW_BG = "#FFF7E6"
